// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 가상 키오스크 스타일 - 가로 태블릿용
 */

.vk-page {
  min-height: 100dvh;
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  display: flex;
  flex-direction: column;
}
.vk-page button, .vk-page input { min-height: auto; }

.vk-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: rgba(255,255,255,0.85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0,0,0,0.06);
  flex-shrink: 0;
}
.vk-header .btn-back {
  background: none;
  border: 2px solid #64B5F6;
  color: #1565C0;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.vk-header .btn-back:active { background: #E3F2FD; }

.vk-header-center {
  display: flex; align-items: center; gap: 10px;
  -webkit-user-select: none;
          user-select: none;
}
.vk-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 20px; color: #1565C0; margin: 0;
}
.vk-header-spacer { width: 72px; }

.vk-content {
  flex: 1 1;
  display: flex;
  gap: 12px;
  padding: 10px 14px;
  overflow: hidden;
}

/* 좌: 조작 */
.vk-left {
  width: 340px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.vk-section {
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.vk-label {
  display: block;
  font-family: 'Jua', sans-serif;
  font-size: 14px;
  color: #1565C0;
  margin-bottom: 8px;
}

.vk-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E0E0E0;
  border-radius: 10px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;
}
.vk-input:focus { border-color: #1E88E5; }

.vk-input-btn {
  background: #fff;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  color: #212121;
  letter-spacing: 0.5px;
  -webkit-tap-highlight-color: transparent;
}
.vk-input-btn:active { background: #F5F5F5; }
.vk-input-btn.is-placeholder { color: #9E9E9E; letter-spacing: normal; }

.vk-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vk-btn {
  padding: 12px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s;
  color: #fff;
}
.vk-btn:active { transform: scale(0.97); }
.vk-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.vk-btn-info { background: linear-gradient(135deg, #1E88E5, #1565C0); }   /* v0.6 쿠폰 조회 */
.vk-btn-ticket { background: linear-gradient(135deg, #43A047, #2E7D32); }
.vk-btn-passport { background: linear-gradient(135deg, #7B1FA2, #4A148C); }
.vk-btn-passport-only { background: linear-gradient(135deg, #AB47BC, #6A1B9A); }
.vk-btn-reset { background: linear-gradient(135deg, #F4511E, #BF360C); width: 100%; }
.vk-btn-delete { background: #C62828; padding: 10px 16px; flex-shrink: 0; }
.vk-btn-clear { background: none; border: 1px solid #ccc; border-radius: 6px; padding: 4px 10px; font-size: 12px; color: #666; cursor: pointer; }

.vk-loading {
  text-align: center; padding: 8px; color: #1565C0; font-size: 14px;
}

/* 기존 여권 보유 시 여권구매 팝업 (모두지우고새여권 / 추가구입 / 취소) */
.vk-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}
.vk-modal {
  width: 100%;
  max-width: 360px;
  background: #fff;
  border-radius: 16px;
  padding: 22px 20px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.3);
}
.vk-modal-title { font-size: 17px; font-weight: 700; color: #4A148C; text-align: center; }
.vk-modal-sub { margin-top: 8px; font-size: 14px; color: #555; text-align: center; line-height: 1.5; }
.vk-modal-q { margin: 16px 0 10px; font-size: 14px; font-weight: 600; color: #333; text-align: center; }
.vk-modal-actions { display: flex; flex-direction: column; gap: 8px; }
.vk-modal-actions .vk-btn { width: 100%; }
.vk-btn-cancel { background: #9E9E9E; }

.vk-delete-section { border-top: 2px dashed #EF9A9A; }
.vk-delete-row { display: flex; gap: 8px; }
.vk-delete-row .vk-input { flex: 1 1; }

.vk-device-row {
  display: flex;
  gap: 8px;
}
.vk-device-row .vk-select:first-child { flex: 1.2 1; }
.vk-device-row .vk-select:last-child { flex: 1 1; }

.vk-select {
  padding: 8px 10px;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  outline: none;
  cursor: pointer;
}
.vk-select:focus { border-color: #1E88E5; }
.vk-select:disabled { background: #F5F5F5; color: #999; cursor: not-allowed; }

.vk-device-preview {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
  text-align: right;
}
.vk-device-preview strong {
  color: #1565C0;
  font-family: monospace;
}

/* 우: 로그 */
.vk-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.vk-log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 14px;
  background: #F5F5F5;
  border-bottom: 1px solid #E0E0E0;
  font-family: 'Jua', sans-serif;
  font-size: 14px;
  color: #333;
  flex-shrink: 0;
}

.vk-log-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}

.vk-log-empty {
  text-align: center;
  color: #999;
  padding: 40px;
  font-size: 14px;
}

.vk-log-item {
  margin-bottom: 6px;
  padding: 8px 10px;
  border-radius: 8px;
  border-left: 3px solid #ccc;
  font-size: 13px;
}

.vk-log-ok { border-left-color: #4CAF50; background: #F1F8E9; }
.vk-log-err { border-left-color: #F44336; background: #FFEBEE; }
.vk-log-del { border-left-color: #FF9800; background: #FFF3E0; }
.vk-log-info { border-left-color: #2196F3; background: #E3F2FD; }

.vk-log-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vk-log-type { font-size: 14px; }
.vk-log-msg { flex: 1 1; font-weight: 500; color: #333; }
.vk-log-time { font-size: 11px; color: #999; }

.vk-log-detail {
  margin: 6px 0 0;
  padding: 6px 8px;
  background: rgba(0,0,0,0.04);
  border-radius: 6px;
  font-size: 11px;
  color: #555;
  white-space: pre-wrap;
  max-height: 120px;
  overflow-y: auto;
}

/* ─── 동탄 회원가입 QR ─── */
.vk-btn-qr {
  background: linear-gradient(135deg, #1E88E5, #1565C0);
}
.vk-btn-qr.is-active {
  background: linear-gradient(135deg, #F57C00, #E65100);
}

.vk-qr-panel {
  flex: 1 1;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  overflow: auto;
}

.vk-qr-title {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #1565C0;
}

.vk-qr-sub {
  font-size: 13px;
  color: #666;
}

.vk-qr-image {
  width: min(360px, 70%);
  height: auto;
  background: #fff;
  padding: 8px;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
}

.vk-qr-url {
  margin-top: 8px;
  font-size: 12px;
  color: #1565C0;
  text-decoration: underline;
  word-break: break-all;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/VirtualKioskPage.css"],"names":[],"mappings":"AAAA;;EAEE;;AAGF;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;AACA,kCAAkC,gBAAgB,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,eAAe,EAAE,cAAc,EAAE,SAAS;AAC5C;AACA,oBAAoB,WAAW,EAAE;;AAEjC;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA,kBAAkB,qBAAqB,EAAE;;AAEzC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,+BAA+B,cAAc,EAAE,sBAAsB,EAAE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,WAAW;AACb;AACA,iBAAiB,sBAAsB,EAAE;AACzC,mBAAmB,YAAY,EAAE,mBAAmB,EAAE;;AAEtD,eAAe,qDAAqD,EAAE,IAAI,eAAe;AACzF,iBAAiB,qDAAqD,EAAE;AACxE,mBAAmB,qDAAqD,EAAE;AAC1E,wBAAwB,qDAAqD,EAAE;AAC/E,gBAAgB,qDAAqD,EAAE,WAAW,EAAE;AACpF,iBAAiB,mBAAmB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC1E,gBAAgB,gBAAgB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEhJ;EACE,kBAAkB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe;AACnE;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACzF,gBAAgB,eAAe,EAAE,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACrG,cAAc,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AACvG,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,4BAA4B,WAAW,EAAE;AACzC,iBAAiB,mBAAmB,EAAE;;AAEtC,qBAAqB,8BAA8B,EAAE;AACrD,iBAAiB,aAAa,EAAE,QAAQ,EAAE;AAC1C,2BAA2B,SAAO,EAAE;;AAEpC;EACE,aAAa;EACb,QAAQ;AACV;AACA,wCAAwC,WAAS,EAAE;AACnD,uCAAuC,SAAO,EAAE;;AAEhD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA,mBAAmB,qBAAqB,EAAE;AAC1C,sBAAsB,mBAAmB,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAE7E;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,aAAa,0BAA0B,EAAE,mBAAmB,EAAE;AAC9D,cAAc,0BAA0B,EAAE,mBAAmB,EAAE;AAC/D,cAAc,0BAA0B,EAAE,mBAAmB,EAAE;AAC/D,eAAe,0BAA0B,EAAE,mBAAmB,EAAE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,eAAe,eAAe,EAAE;AAChC,cAAc,SAAO,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACtD,eAAe,eAAe,EAAE,WAAW,EAAE;;AAE7C;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB","sourcesContent":["/**\n * 가상 키오스크 스타일 - 가로 태블릿용\n */\n@import url('https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap');\n\n.vk-page {\n  min-height: 100dvh;\n  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);\n  display: flex;\n  flex-direction: column;\n}\n.vk-page button, .vk-page input { min-height: auto; }\n\n.vk-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  background: rgba(255,255,255,0.85);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(0,0,0,0.06);\n  flex-shrink: 0;\n}\n.vk-header .btn-back {\n  background: none;\n  border: 2px solid #64B5F6;\n  color: #1565C0;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.vk-header .btn-back:active { background: #E3F2FD; }\n\n.vk-header-center {\n  display: flex; align-items: center; gap: 10px;\n  user-select: none;\n}\n.vk-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px; color: #1565C0; margin: 0;\n}\n.vk-header-spacer { width: 72px; }\n\n.vk-content {\n  flex: 1;\n  display: flex;\n  gap: 12px;\n  padding: 10px 14px;\n  overflow: hidden;\n}\n\n/* 좌: 조작 */\n.vk-left {\n  width: 340px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.vk-section {\n  background: #fff;\n  border-radius: 12px;\n  padding: 12px 14px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n\n.vk-label {\n  display: block;\n  font-family: 'Jua', sans-serif;\n  font-size: 14px;\n  color: #1565C0;\n  margin-bottom: 8px;\n}\n\n.vk-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E0E0E0;\n  border-radius: 10px;\n  font-size: 16px;\n  outline: none;\n  box-sizing: border-box;\n}\n.vk-input:focus { border-color: #1E88E5; }\n\n.vk-input-btn {\n  background: #fff;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  color: #212121;\n  letter-spacing: 0.5px;\n  -webkit-tap-highlight-color: transparent;\n}\n.vk-input-btn:active { background: #F5F5F5; }\n.vk-input-btn.is-placeholder { color: #9E9E9E; letter-spacing: normal; }\n\n.vk-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.vk-btn {\n  padding: 12px;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s;\n  color: #fff;\n}\n.vk-btn:active { transform: scale(0.97); }\n.vk-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.vk-btn-info { background: linear-gradient(135deg, #1E88E5, #1565C0); }   /* v0.6 쿠폰 조회 */\n.vk-btn-ticket { background: linear-gradient(135deg, #43A047, #2E7D32); }\n.vk-btn-passport { background: linear-gradient(135deg, #7B1FA2, #4A148C); }\n.vk-btn-passport-only { background: linear-gradient(135deg, #AB47BC, #6A1B9A); }\n.vk-btn-reset { background: linear-gradient(135deg, #F4511E, #BF360C); width: 100%; }\n.vk-btn-delete { background: #C62828; padding: 10px 16px; flex-shrink: 0; }\n.vk-btn-clear { background: none; border: 1px solid #ccc; border-radius: 6px; padding: 4px 10px; font-size: 12px; color: #666; cursor: pointer; }\n\n.vk-loading {\n  text-align: center; padding: 8px; color: #1565C0; font-size: 14px;\n}\n\n/* 기존 여권 보유 시 여권구매 팝업 (모두지우고새여권 / 추가구입 / 취소) */\n.vk-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n.vk-modal {\n  width: 100%;\n  max-width: 360px;\n  background: #fff;\n  border-radius: 16px;\n  padding: 22px 20px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.3);\n}\n.vk-modal-title { font-size: 17px; font-weight: 700; color: #4A148C; text-align: center; }\n.vk-modal-sub { margin-top: 8px; font-size: 14px; color: #555; text-align: center; line-height: 1.5; }\n.vk-modal-q { margin: 16px 0 10px; font-size: 14px; font-weight: 600; color: #333; text-align: center; }\n.vk-modal-actions { display: flex; flex-direction: column; gap: 8px; }\n.vk-modal-actions .vk-btn { width: 100%; }\n.vk-btn-cancel { background: #9E9E9E; }\n\n.vk-delete-section { border-top: 2px dashed #EF9A9A; }\n.vk-delete-row { display: flex; gap: 8px; }\n.vk-delete-row .vk-input { flex: 1; }\n\n.vk-device-row {\n  display: flex;\n  gap: 8px;\n}\n.vk-device-row .vk-select:first-child { flex: 1.2; }\n.vk-device-row .vk-select:last-child { flex: 1; }\n\n.vk-select {\n  padding: 8px 10px;\n  border: 2px solid #E0E0E0;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #fff;\n  outline: none;\n  cursor: pointer;\n}\n.vk-select:focus { border-color: #1E88E5; }\n.vk-select:disabled { background: #F5F5F5; color: #999; cursor: not-allowed; }\n\n.vk-device-preview {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #666;\n  text-align: right;\n}\n.vk-device-preview strong {\n  color: #1565C0;\n  font-family: monospace;\n}\n\n/* 우: 로그 */\n.vk-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  overflow: hidden;\n}\n\n.vk-log-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 14px;\n  background: #F5F5F5;\n  border-bottom: 1px solid #E0E0E0;\n  font-family: 'Jua', sans-serif;\n  font-size: 14px;\n  color: #333;\n  flex-shrink: 0;\n}\n\n.vk-log-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.vk-log-empty {\n  text-align: center;\n  color: #999;\n  padding: 40px;\n  font-size: 14px;\n}\n\n.vk-log-item {\n  margin-bottom: 6px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border-left: 3px solid #ccc;\n  font-size: 13px;\n}\n\n.vk-log-ok { border-left-color: #4CAF50; background: #F1F8E9; }\n.vk-log-err { border-left-color: #F44336; background: #FFEBEE; }\n.vk-log-del { border-left-color: #FF9800; background: #FFF3E0; }\n.vk-log-info { border-left-color: #2196F3; background: #E3F2FD; }\n\n.vk-log-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.vk-log-type { font-size: 14px; }\n.vk-log-msg { flex: 1; font-weight: 500; color: #333; }\n.vk-log-time { font-size: 11px; color: #999; }\n\n.vk-log-detail {\n  margin: 6px 0 0;\n  padding: 6px 8px;\n  background: rgba(0,0,0,0.04);\n  border-radius: 6px;\n  font-size: 11px;\n  color: #555;\n  white-space: pre-wrap;\n  max-height: 120px;\n  overflow-y: auto;\n}\n\n/* ─── 동탄 회원가입 QR ─── */\n.vk-btn-qr {\n  background: linear-gradient(135deg, #1E88E5, #1565C0);\n}\n.vk-btn-qr.is-active {\n  background: linear-gradient(135deg, #F57C00, #E65100);\n}\n\n.vk-qr-panel {\n  flex: 1;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  overflow: auto;\n}\n\n.vk-qr-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #1565C0;\n}\n\n.vk-qr-sub {\n  font-size: 13px;\n  color: #666;\n}\n\n.vk-qr-image {\n  width: min(360px, 70%);\n  height: auto;\n  background: #fff;\n  padding: 8px;\n  border: 1px solid #E0E0E0;\n  border-radius: 12px;\n}\n\n.vk-qr-url {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #1565C0;\n  text-decoration: underline;\n  word-break: break-all;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
